import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Layout from '@/layout';
export default {
  path: '/systemAdmin',
  component: Layout,
  redirect: '/systemAdmin/permission',
  name: 'systemAdmin',
  meta: {
    title: '系统管理',
    icon: 'xitong'
  },
  hidden: false,
  children: [{
    path: 'permission',
    component: function component() {
      return import('@/views/systemAdmin/permission/index.vue');
    },
    name: 'permission',
    meta: {
      title: '功能管理'
    },
    hidden: false
  }, {
    path: 'roleAdmin',
    component: function component() {
      return import('@/views/systemAdmin/roleAdmin/index.vue');
    },
    name: 'roleAdmin',
    meta: {
      title: '角色管理'
    },
    hidden: false
  }, {
    path: 'operatorAdmin',
    component: function component() {
      return import('@/views/systemAdmin/operatorAdmin/index.vue');
    },
    name: 'operatorAdmin',
    meta: {
      title: '操作员管理'
    },
    hidden: false
  }, {
    path: 'passwordEdit',
    component: function component() {
      return import('@/views/systemAdmin/passwordEdit/index.vue');
    },
    name: 'passwordEdit',
    meta: {
      title: '密码修改'
    },
    hidden: false
  }, {
    path: 'operateList',
    component: function component() {
      return import('@/views/systemAdmin/operateList/index.vue');
    },
    name: 'operateList',
    meta: {
      title: '操作记录'
    },
    hidden: false
  }, {
    path: 'loginLog',
    component: function component() {
      return import('@/views/systemAdmin/loginLog/index.vue');
    },
    name: 'loginLog',
    meta: {
      title: '登录日志'
    },
    hidden: false
  }]
};